<script>
import { Bar, mixins } from "vue-chartjs";
import _ from "../../views/Utility/utility";
const { reactiveProp } = mixins;

export default {
    extends: Bar,
    mixins: [reactiveProp],
    computed: {
        options() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: true,
                    titleFontSize: 14,
                    titleMarginBottom: 8,
                    bodyFontSize: 15,
                    bodySpacing: 10,
                    callbacks: {
                        label: (tooltipItems, data) => {
                            const datasetIndex = tooltipItems.datasetIndex;
                            const label = data.datasets[datasetIndex].label;
                            return `${label}: ${(tooltipItems.value)}%`;
                        },
                    },
                },
                onClick: this.handle,
                scales: {
                    xAxes: [{
                        stacked: true,
                        display: false // Hide X axis labels
                    }],
                    yAxes: [{
                        stacked: false,    //this needs to be false
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            callback: function (value) {
                                return value.toString() + "%";
                            }
                        },
                        afterTickToLabelConversion: function (q) {
                            for (var tick in q.ticks) {
                                q.ticks[tick] = (
                                    q.ticks[tick]
                                );
                            }
                        },
                    }],
                },
            };
        },
    },
    mounted() {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options);
    },
    methods: {
        handle(point, event) {
            const item = event[0];
            this.$emit("on-receive", {
                index: item._index,
                value: this.chartData.datasets[0].data[item._index],
                label: this.chartData.labels[item._index],
                vendor: this.chartData.tooltipLabels[item._index],
            });
        },
    },
};
</script>
